export class CompanyStatus {

    public static readonly ENABLED = new CompanyStatus('ENABLED');
    public static readonly DISABLED = new CompanyStatus('DISABLED');

    private constructor(public readonly status: string) {}

    public static values(): CompanyStatus[] {
        return [
            CompanyStatus.ENABLED,
            CompanyStatus.DISABLED,
        ];
    }

    public static get(status: string): CompanyStatus {
        const companyStatus = CompanyStatus.values().find(it => it.status === status);
        return companyStatus;
    }
}
